export const LANDING_ROUTES = {
  signin: '/signin',
  signup: '/signup',
  persona: '/persona',
  acceptTerms: '/accept-terms',
  provideEmail: '/provide-email',
};
